__turbopack_context__.v({
  "mobileButtonContainer": "styles-module-scss-module__xtX-hq__mobileButtonContainer",
  "mobileSearchContainer": "styles-module-scss-module__xtX-hq__mobileSearchContainer",
  "searchToggle": "styles-module-scss-module__xtX-hq__searchToggle",
  "slideDown": "styles-module-scss-module__xtX-hq__slideDown",
  "slideUp": "styles-module-scss-module__xtX-hq__slideUp",
});
